import { render, staticRenderFns } from "./referral-rule-form-modal.vue?vue&type=template&id=7c417313"
import script from "./referral-rule-form-modal.vue?vue&type=script&lang=ts"
export * from "./referral-rule-form-modal.vue?vue&type=script&lang=ts"
import style0 from "./referral-rule-form-modal.vue?vue&type=style&index=0&id=7c417313&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports